// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"436":"successfulCase","443":"about","679":"intellectualproperty"}[chunkId] + "." + {"436":"8d5862c8","443":"ee1789a7","679":"abc4701d"}[chunkId] + ".js";
};